import { render, staticRenderFns } from "./MyBreadcrumb.vue?vue&type=template&id=11f3bc38&scoped=true"
import script from "./MyBreadcrumb.vue?vue&type=script&lang=js"
export * from "./MyBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./MyBreadcrumb.vue?vue&type=style&index=0&id=11f3bc38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f3bc38",
  null
  
)

export default component.exports